import { render, staticRenderFns } from "./RestaurantModest.vue?vue&type=template&id=df8d11f0&scoped=true"
import script from "./RestaurantModest.vue?vue&type=script&lang=js"
export * from "./RestaurantModest.vue?vue&type=script&lang=js"
import style0 from "./RestaurantModest.vue?vue&type=style&index=0&id=df8d11f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8d11f0",
  null
  
)

export default component.exports